<template>
  <div>
    <div class="title-h4">패턴 설정</div>
    <el-form ref="patternForm" label-position="top" :model="{ dataindexId, patternId }" :rules="formRules">
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="저장소">
            <el-select v-model="dataindexId">
              <el-option label="미배정" :value="null" />
              <el-option v-for="index in dataindexes" :key="index.dataindexId" :label="index.dataindexName" :value="index.dataindexId"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="파싱 패턴" prop="patternId">
            <el-select v-model="patternId" :disabled="!dataindexId">
              <el-option v-for="item in patterns" :key="item.patternId" :label="item.patternName" :value="item.patternId">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-form-item label="정규표현식">
          <el-input
            type="textarea"
            resize="none"
            :rows="3"
            v-model="patternRegex" :disabled="true">
          </el-input>
        </el-form-item>
      </el-row>
      <el-row>
        <el-form-item label="머신러닝 패턴 사용">
          <span slot="label">
            <span class="mr-r4">머신러닝 패턴 사용</span>
            <el-popover placement="bottom" width="500" trigger="hover" :offset="40">
              <span class="text"> - 머신러닝 패턴은 같은 패턴의 로그가 <em>25개 </em>이상 발생해야 생성됩니다.</span>
              <span slot="reference"><i class="fas fa-info-circle" style="cursor: pointer"></i></span>
            </el-popover>
          </span>
          <el-switch v-model="mlFlag" active-value="Y" inactive-value="N" />
        </el-form-item>
      </el-row>
    </el-form>
  </div>
</template>

<script>
import { isNil, isEmpty, find } from 'lodash';

import msgUtils from '@/utils/message';
import IntegratedSyslogSettingAPI from '@/api/settings/log/integrated-syslog-settings';

export default {
  name: 'WPatternSettingPopupContent',
  props: {
    logInfo: Object,
    disabled: Boolean,
  },
  data() {
    const patternValidation = (rule, value, callback) => {
      if (!isNil(this.dataindexId) && isNil(value)) {
        callback(new Error('패턴을 선택해주세요.'));
      } else {
        callback();
      }
    };

    const formRules = {
      patternId: [
        { validator: patternValidation, trigger: 'blur' },
      ],
    };
    return {
      formRules,
      dataindexes: [],
      patterns: [],
      dataindexId: null,
      patternId: null,
      mlFlag: null,
      patternRegex: null,
      patternInfo: {},
    };
  },
  watch: {
    logInfo: {
      immediate: true,
      deep: true,
      handler(value) {
        if (!isEmpty(value) && !isNil(value.dataindexId) && !isNil(value.patternId)) {
          this.patternId = value.patternId;
          this.dataindexId = value.dataindexId;
          this.mlFlag = value.mlFlag;
        }
      },
    },
    dataindexId(value) {
      this.patternId = null;
      if (!isNil(value)) {
        this.loadPattern(value);
      }
    },
    patternId(value) {
      const patternInfo = find(this.patterns, { patternId: value });
      if (!isEmpty(patternInfo)) {
        this.patternRegex = patternInfo.patternRegex;
      }
    },
  },
  created() {
    this.loadDataindex();
  },
  methods: {
    /**
     * 저장소 선택 콤보박스의 데이터 조회
     * @author Minyeong
     * @return {[type]} [description]
     */
    loadDataindex() {
      IntegratedSyslogSettingAPI.getDataIndexes().then((response) => {
        if (response.data.success) {
          this.dataindexes = response.data.data;
        }
      }).catch((e) => {
        this.$message(msgUtils.getResultMsgData(msgUtils.action.VIEW, '저장소', false));
        throw new Error(e);
      });
    },
    /**
     * 콤보박스에서 저장소 선택하면 해당 dataindexId로 저장소에 속한 패턴 목록 조회
     * @author Minyeong
     * @param  {[type]} dataindexId [description]
     * @return {[type]}             [description]
     */
    loadPattern(dataindexId) {
      const params = {
        params: {
          dataindexId,
        },
      };
      IntegratedSyslogSettingAPI.getPatternByIndex(params).then((response) => {
        if (response.data.success) {
          this.patterns = response.data.data;
          if (!isEmpty(this.patterns)) {
            this.patternId = this.patterns[0].patternId;
          } else {
            this.$message(msgUtils.getCustomMsgData('패턴을 생성해주세요.'));
          }
        }
      }).catch((e) => {
        this.$message(msgUtils.getCustomMsgData('패턴을 생성해주세요.'));
        throw new Error(e);
      });
    },
    initData() {
      this.dataindexId = null;
    },
    getPatternParam() {
      return { dataindexId: this.dataindexId, patternId: this.patternId, mlFlag: this.mlFlag };
    },
    checkValidation() {
      this.$refs.patternForm.validate().then((success) => {
        if (success) {
          this.$emit('update-log-info');
        }
      }).catch(() => {});
    },
    initValidation() {
      const clear = ['patternId'];
      this.$refs.patternForm.clearValidate(clear);
    },
  },
};
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/views/settings/log-analysis/Collect/Syslog/components/PatternSettingPopupContent.vue